export const DefaultLower = {
    rawCopy: "<strong>Keep up the good work</strong> with the help of the " +
        "<u>free&nbsp;DrinkCoach&nbsp;app!</u>",
    logoLink: "https://drinkcoach.org.uk/download-drinkcoach-app"
};
export const DefaultIncreasing = {
    rawCopy: "For Increasing Risk scores we recommend you cut down your drinking. Click here to " +
        "<u>book an online appointment</u> with an alcohol specialist.",
    logoLink: "https://drinkcoach.bookinglive.com/"
};
export const DefaultHigher = {
    rawCopy: "For Higher Risk scores we recommend you cut down your drinking. Click here to " +
        "<u>book an online appointment</u> with an alcohol specialist.",
    logoLink: "https://drinkcoach.bookinglive.com/"
};
export const DefaultHigh = {
    rawCopy: "For <strong>High Risk/Possible Dependence</strong> scores we strongly recommend seeking " +
        "advice from a GP or <u>local&nbsp;alcohol&nbsp;service.</u>",
    logoLink: "find-support"
};
export const NullBanner = {
    rawCopy: "",
    logoLink: ""
};
//# sourceMappingURL=DefaultBanners.js.map